import { useEffect, useState } from "react";
import { Loader } from "../../common/Loader";
import { PaymentFailure } from "../failure/PaymentFailure";
import PaymentSuccess from "../success";
import { transactionDetailsApiUrl } from "../../environment";

const RedirectionPage = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState(true);
  const [isWaiting, setIsWaiting] = useState(false);
  const [err, setErr] = useState("");
  const [paymentDetails, setPaymentDetails] = useState<any>({
    amount: "",
    paymentType: "",
    transactionNo: "",
    status: "",
    applicationNo: "",
    errorDetails: null,
  });

  const fetchDetailsandValidate = async (crrId: string) => {
    try {
      const jsonData = await fetch(`${transactionDetailsApiUrl}/${crrId}`);
      if (!jsonData.ok) {
        throw new Error(`Error ${jsonData.status}`);
      }

      const parsedResponse = await jsonData.json();

      const apiData = parsedResponse?.data;

      return apiData;
    } catch (err: any) {
      setErr(err);
      setIsWaiting(true);
    }
  };

  useEffect(() => {
    const path = window.location.pathname;
    const epgId = path.split("/")[2];

    const baseUrl = `${window.location.origin}/payment-response`;
    const params = new URLSearchParams();
    const successsRouting = (apidata: any) => {
      params.append("status", "success");
      params.append("transaction_id", apidata?.transactionNo);
      const neeUrl = new URL(baseUrl);
      neeUrl.search = params.toString();
      window.history.replaceState(window.history.state, "", neeUrl);
    };

    const cancelRouting = () => {
      params.append("status", "canceled");
      const neeUrl = new URL(baseUrl);
      neeUrl.search = params.toString();
      window.history.replaceState(window.history.state, "", neeUrl);
    };

    const failureRouting = () => {
      params.append("status", "failed");
      const neeUrl = new URL(baseUrl);
      neeUrl.search = params.toString();
      window.history.replaceState(window.history.state, "", neeUrl);
    };

    const waitingRouting = () => {
      params.append("status", "waiting");
      const neeUrl = new URL(baseUrl);
      neeUrl.search = params.toString();
      window.history.replaceState(window.history.state, "", neeUrl);
    };

    const retryApiCall = async () => {
      let apidata;
      for (let i = 0; i < 5; i++) {
        apidata = await fetchDetailsandValidate(epgId);

        if (apidata?.status === "SUCCESS" || apidata?.errorDetails) {
          break;
        }

        await new Promise((resolve) => setTimeout(resolve, 5000));
      }
      if (apidata?.status === "SUCCESS") {
        setIsLoading(false);
        successsRouting(apidata);
      } else if (apidata?.errorDetails?.[0]?.errorCode === "EPG_6824") {
        setIsLoading(false);
        cancelRouting();
      } else if (apidata?.errorDetails) {
        setIsLoading(false);
        failureRouting();
      } else waitingRouting();
      setPaymentDetails(apidata);
    };
    retryApiCall();
  }, []);

  return (
    <>
      {isLoading || isWaiting ? (
        <Loader />
      ) : (
        <>
          {paymentDetails?.status === "SUCCESS" ? (
            <PaymentSuccess
              amount={paymentDetails?.amount}
              paymentType={paymentDetails?.paymentType}
              transactionNo={paymentDetails?.transactionNo}
              status={paymentDetails?.status}
              applicationNo={paymentDetails.applicationNo}
            />
          ) : (
            <PaymentFailure
              status={paymentDetails?.status}
              errorDetails={paymentDetails?.errorDetails}
            />
          )}
        </>
      )}
    </>
  );
};

export default RedirectionPage;
